import { render, staticRenderFns } from "./coupon-editor.vue?vue&type=template&id=67883806&scoped=true&"
import script from "./coupon-editor.vue?vue&type=script&lang=js&"
export * from "./coupon-editor.vue?vue&type=script&lang=js&"
import style0 from "./coupon-editor.vue?vue&type=style&index=0&id=67883806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67883806",
  null
  
)

export default component.exports